module.exports = "<div class=\"c-go_to_home\" (click)=\"onGoToHome()\">\n  <img class=\"c-go_to_home__img\" src=\"assets/icons/home-icon.png\" />\n</div>\n"